'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n\n  > *:not(:first-child) {\n    display: none;\n  }\n\n  @media(min-width: ', ') {\n    width: 500px;\n  }\n'], ['\n  width: 100%;\n\n  > *:not(:first-child) {\n    display: none;\n  }\n\n  @media(min-width: ', ') {\n    width: 500px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    float: right;\n\n    ', '\n  '], ['\n    float: right;\n\n    ', '\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    float: left;\n\n    ', '\n  '], ['\n    float: left;\n\n    ', '\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    > *:not(:last-child) {\n      margin: 0 0 30px 0;\n    }\n\n    @media(min-width: ', ') {\n      > *:not(:last-child) {\n        margin: 0 30px 0 0;\n      }\n    }\n  '], ['\n    > *:not(:last-child) {\n      margin: 0 0 30px 0;\n    }\n\n    @media(min-width: ', ') {\n      > *:not(:last-child) {\n        margin: 0 30px 0 0;\n      }\n    }\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  justify-content: space-around;\n  background-color: ', ';\n  padding: 60px 30px;\n  width: 100%;\n\n  > *:not(:only-child) {\n    max-width: 250px;\n  }\n\n  > *:only-child {\n    max-width: 450px;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 60px;\n    flex-direction: row;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 80px;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 100px;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 120px;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 140px;\n  }\n\n  ', '\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  justify-content: space-around;\n  background-color: ', ';\n  padding: 60px 30px;\n  width: 100%;\n\n  > *:not(:only-child) {\n    max-width: 250px;\n  }\n\n  > *:only-child {\n    max-width: 450px;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 60px;\n    flex-direction: row;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 80px;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 100px;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 120px;\n  }\n\n  @media(min-width: ', ') {\n    padding: 0px 140px;\n  }\n\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _transparentize = require('polished/lib/color/transparentize');

var _transparentize2 = _interopRequireDefault(_transparentize);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COLOR_MAP = {
  blue: _config.colors.darkBlue,
  red: _config.colors.darkRed
};

var commonAlignmentStyles = (0, _styledComponents.css)(_templateObject, _config.breakpoints.m);

var ALIGNMENT_MAP = {
  right: (0, _styledComponents.css)(_templateObject2, commonAlignmentStyles),
  left: (0, _styledComponents.css)(_templateObject3, commonAlignmentStyles),
  full: (0, _styledComponents.css)(_templateObject4, _config.breakpoints.m)
};

var ContentWrapper = _styledComponents2.default.div(_templateObject5, function (props) {
  return (0, _transparentize2.default)(0.1, COLOR_MAP[props.color] || COLOR_MAP.blue);
}, _config.breakpoints.m, _config.breakpoints.l, _config.breakpoints.xl, _config.breakpoints.xxl, _config.breakpoints.xxxl, function (props) {
  return ALIGNMENT_MAP[props.alignment];
});

ContentWrapper.displayName = 'ContentWrapper';

exports.default = ContentWrapper;